import $http from '../services/AxiosInstance';
import { IWhiteListOfacRecord } from '../types/whiteListOfac.type';


interface Params {
  page?: number;
  search?: string;
  deleted?: boolean;
}

class WhiteListOfacRepository {
  static async getWhiteListOfac(params: Params = {}) {
    try {
      let url = `/white-list-ofac`;
      if(params.page){
        url += `?page=${params.page}`;
      }
      if (params.search) {
        url += `&search=${params.search}`;
      }
      if (params.deleted) {
        url += `&deleted=${params.deleted}`;
      }
      const response = await $http.get(url);
      return response.data;
    } catch (errors: any) {
      throw Error;
    }
  }
  static async createWhiteListOfacRecord(data: IWhiteListOfacRecord): Promise<IWhiteListOfacRecord> {
    try {
      const response = await $http.post('/white-list-ofac', data);

      return response.data.data;
    } catch (error) {
      throw Error;
    }
  }
  static async updateWhiteListOfacRecord(data: IWhiteListOfacRecord): Promise<IWhiteListOfacRecord> {
    try {
      const response = await $http.patch(`/white-list-ofac/${data.id}`, data);
      return response.data.data;
    } catch (error) {
      throw Error;
    }
  }
}

export default WhiteListOfacRepository;
